/**
 * Navigation - Mega Menu Toggle
 */

// Handle anchor scroll on page load (cross-page navigation)
if (window.location.hash) {
  // Prevent browser default scroll, then scroll manually after page renders
  window.scrollTo(0, 0);
  window.addEventListener('load', () => {
    const target = document.querySelector(window.location.hash);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.header__menu-toggle');
  const megaMenu = document.getElementById('mega-menu');
  const body = document.body;

  if (!toggle || !megaMenu) return;

  function openMenu() {
    megaMenu.classList.add('is-open');
    megaMenu.setAttribute('aria-hidden', 'false');
    toggle.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
    body.classList.add('menu-open');
  }

  function closeMenu() {
    megaMenu.classList.remove('is-open');
    megaMenu.setAttribute('aria-hidden', 'true');
    toggle.classList.remove('is-active');
    toggle.setAttribute('aria-expanded', 'false');
    body.classList.remove('menu-open');
  }

  toggle.addEventListener('click', () => {
    if (megaMenu.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && megaMenu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Close menu when clicking a link inside it, and handle anchor scroll
  megaMenu.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    if (!link) return;

    closeMenu();

    // Handle same-page anchor links
    const url = new URL(link.href, window.location.origin);
    if (url.pathname === window.location.pathname && url.hash) {
      e.preventDefault();
      const target = document.querySelector(url.hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 50);
      }
    }
  });

  // Mobile accordion for mega menu titles
  const menuTitles = megaMenu.querySelectorAll('.mega-menu__title');
  menuTitles.forEach((title) => {
    title.addEventListener('click', (e) => {
      if (window.innerWidth > 768) return;

      // Find the next sibling list
      const list = title.nextElementSibling;
      if (!list || !list.classList.contains('mega-menu__list')) return;

      // Prevent link navigation and stop event from closing the menu
      e.preventDefault();
      e.stopPropagation();

      const isExpanded = title.classList.contains('is-expanded');

      // Close all others
      menuTitles.forEach((t) => {
        t.classList.remove('is-expanded');
        const l = t.nextElementSibling;
        if (l && l.classList.contains('mega-menu__list')) {
          l.classList.remove('is-expanded');
        }
      });

      // Toggle current
      if (!isExpanded) {
        title.classList.add('is-expanded');
        list.classList.add('is-expanded');
      }
    });
  });
});

// Mobile: hide header on scroll down, show on scroll up
(function () {
  if (window.innerWidth > 768) return;

  var header = document.querySelector('.header');
  if (!header) return;

  var lastY = window.scrollY;
  var ticking = false;

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        var currentY = window.scrollY;
        if (currentY > lastY && currentY > 60) {
          header.classList.add('header--hidden');
          document.body.classList.add('header-is-hidden');
        } else {
          header.classList.remove('header--hidden');
          document.body.classList.remove('header-is-hidden');
        }
        lastY = currentY;
        ticking = false;
      });
      ticking = true;
    }
  });
})();
